<script setup lang="ts">
import { ref } from "vue";
const isActive = ref(true);

const props = defineProps<{
  videoSrc: string;
  title: string;
  description: string;
  imageCover: string;
  copyrightHolder: string;
}>();
</script>

<template>
  <div class="for-explorers-card" :class="{ isActive }">
    <video
      v-motion-fade-visible-once
      playsinline
      autoplay
      muted
      loop
      :poster="props.imageCover"
    >
      <source :src="props.videoSrc" type="video/webm" />
      <meta
        :itemprop="props.copyrightHolder"
        :content="props.copyrightHolder"
      />
    </video>
    <div class="overlay">
      <h4 v-motion-slide-visible-once-bottom :delay="100">{{ props.title }}</h4>
      <p
        v-motion-slide-visible-once-bottom
        :delay="200"
        class="typeface-regular"
      >
        {{ props.description }}
      </p>
    </div>
  </div>
</template>

<style scoped lang="postcss">
.for-explorers-card {
  height: 100%;
  width: 100%;
  position: relative;

  video {
    border-radius: 1rem;
    object-fit: cover;
    height: 100%;
    width: 100%;
  }

  img {
    border-radius: 1rem;
    width: 100%;
  }

  .overlay {
    box-sizing: border-box;
    position: absolute;
    top: -1px;
    left: -1px;
    height: 100%;
    width: 100%;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #070707 100%);
    color: var(--color-slate-100);
    border-radius: 1rem;
    align-content: end;
    padding: 0 1.5rem 0.5rem 1.5rem;
    display: flex;
    flex-direction: column;
    place-content: end;

    button {
      background-color: var(--color-slate-50);
      color: var(--color-slate-900);
      width: 100%;
      text-align: left;
    }

    h4 {
      font-weight: 600;
      margin: 0 0 0.5rem;
    }

    p {
      color: var(--color-slate-200);
      margin-top: 0.25rem;
    }
  }
}
</style>
